import { Link } from "react-router-dom";
import { COLORS, SCREEN_LG } from "shared/consts";
import { toEm, toRem } from "shared/helpers";
import styled, { css } from "styled-components";

type HiveAudiosWrapperProps = {
  $isVidget?: boolean
}
export const HiveAudiosWrapper = styled.div<HiveAudiosWrapperProps>`
  height: 100%;
  ${({$isVidget}) => $isVidget && css`
    overflow: clip auto;
    scrollbar-width: none;
    padding: ${toRem(16)};
  `}

  @media (width < ${toEm(SCREEN_LG)}){
    padding-bottom: ${toRem(76)};
  }
`;

export const HiveAudiosHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${toRem(12)};

  &:not(:last-child) {margin-bottom: ${toRem(16)};}
`;

export const HiveAudiosTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: ${toRem(4)};
  font-weight: 700;
  font-size: ${toRem(16)};
  line-height: ${24 / 16};
`;

export const HiveAudiosLink = styled(Link)`
  display: flex;
  align-items: center;
  color: ${COLORS.FG.MUTED};

  @media (any-hover: hover){
    &:hover{
      text-decoration: underline;
    }
  }
`;

export const AudioItemWrapper = styled.div`
  background-color: ${COLORS.BG.SURFACE3};
  padding: ${toRem(16)};
  border-radius: ${toRem(12)};
  max-width: ${toRem(640)};
  position: relative;

  &:not(:last-child) {margin-bottom: ${toRem(12)};}

  audio {
    position: absolute;
    top: 0;
    left: 100%;
    width: 0;
    height: 0;
    opacity: 0;
    pointer-events: none;
  }
`;

export const AudioItemHead = styled.div`
  padding-left: ${toRem(28)};
  display: flex;
  gap: ${toRem(4)};
  font-size: ${toRem(12)};
`;

export const AudioItemHive = styled.div``;

export const AudioItemDate = styled.div`
  color: ${COLORS.FG.MUTED};
`;

export const AudioItemTag = styled.p`
  padding: ${toRem(3)} ${toRem(6)} ${toRem(1)};
  background-color: rgba(215, 14, 14, 0.1);
  border-radius: ${toRem(9999)};
  color: rgba(255, 0, 0, 1);
  font-size: ${toRem(10)};
  line-height: ${12 / 10};
  letter-spacing: ${toRem(0.4)};
  &:first-of-type {
    margin-left: auto;
  }
`;

export const AudioItemControls = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${toRem(8)};
`;

export const AudioItemControlsButton = styled.div`
  cursor: pointer;
  flex: 0 0 ${toRem(20)};
  width: ${toRem(20)};
  aspect-ratio: 1;
`;

export const AudioItemControlsLine = styled.div`
  overflow: hidden;
  flex: 1 1 auto;
  padding: ${toRem(6)} 0;

  input {
    height: ${toRem(4)};
    accent-color: ${COLORS.ACCENT.DEFAULT};
    background-color: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
    cursor: pointer;
    box-shadow: none;
    outline: none;
    appearance: none;
    border-radius: ${toRem(99999)};
    position: relative;
    /* overflow: hidden; */
    &::before{
      content:'';
      position: absolute;
      left: 0;
      top: 0;
      height: ${toRem(4)};
      width: var(--width);
      background-color: ${COLORS.ACCENT.DEFAULT};
      border-radius: ${toRem(9999)};
    }

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      background-color: ${COLORS.ACCENT.DEFAULT};
      border: 0px solid ${COLORS.ACCENT.DEFAULT};
      border-radius: 50%;
      height: ${toRem(16)};
      width: ${toRem(16)};
    }
  }
`;

export const AudioItemControlsTime = styled.div`
  font-size: ${toRem(12)};
  line-height: ${16 / 12};
  color: ${COLORS.FG.MUTED};
`;